export default __webpack_public_path__ + "static/media/whatsapp.94af5025.svg";